<template>
    <form
        novalidate
        class=""
        @submit.prevent="onSubmit"
    >
        <div class="form-group mb-4">
            <div>
                見込みユーザー
                <v-select :get-option-label="getCompanyLabel"
                          :options="potentialUsers"
                          :reduce="company => company.id"
                          :filterBy="customFilerBy"
                          v-model.number="potentialUserSelected">
                </v-select>
            </div>
        </div>

        <div class="form-group mb-4">
            何を
            <v-select label="name"
                      :options="products"
                      :reduce="name => name.id"
                      v-model="productSelected">
            </v-select>
        </div>

        <div class="form-group mb-4">
            <div class="row align-items-md-end">
                <div class="col-md-4 mb-3">
                    <label for="priceInput" class="form-label">単価いくらで</label>
                    <div class="input-group">
                        <input id="priceInput" class="form-control" type="text" v-model.trim="priceInput" placeholder="数字を入力">
                        <div class="input-group-text">円</div>
                    </div>
                </div>
                <div class="col-md-4 mb-3">
                    <label for="quantityInput" class="form-label">数量</label>
                    <input id="quantityInput" class="form-control" type="text" v-model.trim="quantityInput" placeholder="数字を入力">
                </div>
                <div class="col-md-4 mb-3">
                    <label for="unitInput" class="form-label">単位</label>
                    <input id="unitInput" class="form-control" type="text" v-model="unitInput" placeholder="ケースなどを入力">
                </div>
                <div class="col-md-4 mb-md-0 mb-3">
                    <label for="priceInput" class="form-label">確度は</label>
                    <select class="form-control" v-model="accuracySelected">
                        <option disabled value="">確度</option>
                        <option v-for="item in accuracyItem" :value="item.value">
                            {{ item.name }}
                        </option>
                    </select>
                </div>
            </div>
        </div>

        <div class="row align-items-end border-bottom mb-4">
            <span class="fs-2 col-auto">金額.</span>
            <span class="fs-3 col-auto">{{ calculate }}円</span>
        </div>

        <div class="form-group row mb-4">
            <div class="col-md-4 col-12 mb-3 datepicker-w">
                <p class="mb-1">いつ頃<span v-if="hasThisDate">({{ thisDate }})</span></p>
                <v-date-picker
                    :mode="datePicker.mode"
                    :formats="datePicker.formats"
                    :min-date='datePicker.min'
                    v-model="datePickerInput"
                    ref="datepicker">
                </v-date-picker>
            </div>
            <div class="col-md-7 col-12 mt-md-4">
                <div class="form-floating">
                    <textarea id="floatingTextarea" class="form-control rounded-2 min-h-100px" v-on:input="textarea" v-model="noteInput"></textarea>
                    <label for="floatingTextarea">メモ</label>
                </div>
            </div>
        </div>

        <div class="form-group row justify-content-center mb-2">
            <button type="submit" class="btn btn-primary col-3 me-2">保存</button>
            <button type="button" class="btn btn-secondary col-3 ms-2" v-on:click="move('list')">一覧に戻る</button>
        </div>
    </form>
</template>

<script>
import axios from "axios";
import {format} from 'date-fns'

const moji = require('../../moji');

export default {
    props: {
        faqId: Number,
        adminUserId: Number,
        listUrl: String,
        userType: {
            type: Number,
            default: 2
        },
        potentialUser: {
            type: String,
            default: null,
        },
        customer: String,
        product: String,
        price: Number,
        quantity: Number,
        unit: String,
        accuracy: Number,
        scheduled: String,
        note: String
    },
    data() {
        return {
            potentialUsers: [],
            customers: [],
            products: [],
            accuracyItem: [],
            userTypeSelected: this.userType,
            customerSelected: '',
            potentialUserSelected: '',
            productSelected: '',
            priceInput: this.price || "",
            quantityInput: this.quantity || 1,
            unitInput: this.unit || '',
            accuracySelected: this.accuracy || '',
            datePicker: {
                mode: 'single',
                formats: {
                    input: ['YYYY-MM-DD']
                },
                props: {
                    class: 'input',
                    name: 'datePickerInput',
                    placeholder: '日付を選択'
                },
                min: this.getDate(this.scheduled) || new Date()
            },
            datePickerInput: '',
            noteInput: this.note || '',
            noteHeight: 0,
            isChanges: null,
        }
    },
    watch: {
        priceInput: function(v) {
            this.priceInput = v.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) {
                return String.fromCharCode(s.charCodeAt(0) - 65248)
            });
        },
        quantityInput: function(v) {
            this.quantityInput = v.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) {
                return String.fromCharCode(s.charCodeAt(0) - 65248)
            });
        },
    },
    computed: {
        isCustomer() {
            return this.userTypeSelected === 1;
        },
        isPotentialUser(){
            return this.userTypeSelected === 2;
        },
        calculate() {
            if (this.priceInput == null) {
                return 0;
            }
            if (this.quantityInput < 1) {
                return 0;
            }

            let calc = this.priceInput * this.quantityInput;
            if(calc == null || isNaN(calc)){
                return 0;
            }

            return calc.toLocaleString();
        },
        hasThisDate() {
            if (this.datePickerInput === '') {
                return false;
            }
            return this.datePickerInput != null;
        },
        thisDate() {
            if (this.hasThisDate) {
                return format(new Date(this.datePickerInput), 'yyyy/MM/dd');
            }
        }
    },
    async mounted() {
        this.customers = await this.api('/api/faq/customers', {});

        this.potentialUsers = await this.api('/api/faq/potentialUsers', {});
        if (!(this.potentialUsers.length > 0)) {
            alert("見込みユーザー情報を取得できませんでした\nページを更新してください");
        }

        this.products = await this.api('/api/faq/products', {});
        if (!(this.products.length > 0)) {
            alert("商品情報を取得できませんでした\nページを更新してください");
        }

        this.accuracyItem = await this.api('/api/faq/accuracy', {});

        if (this.customer != null) {
            this.customerSelected = this.customer
        }

        if (this.potentialUser != null) {
            this.potentialUserSelected = this.potentialUser
        }

        if (this.product != null) {
            this.productSelected = this.product
        }

        if (this.scheduled != null) {
            this.datePickerInput = this.scheduled;
            const datepicker = this.$refs.datepicker;
            datepicker.move(this.datePickerInput);
        }

        this.noteHeight = document.getElementById('floatingTextarea').clientHeight;
        this.textarea();
    },
    methods: {
        async api(url, params) {
            return axios.post(
                url,
                Object.assign({
                    'id': this.adminUserId
                }, params)
            ).then(res => {
                if (typeof res.data !== 'object') {
                    return [];
                }
                return res.data;
            }).catch(error => {
                console.log(error);
                if (error.response) {
                    let data = error.response.data;
                    if (data.errors) {
                        return data;
                    }
                }
                return [];
            });
        },
        reload(msg) {
            if (msg != null) {
                alert(msg);
            }
            location.reload();
        },
        move(type) {
            if (type === 'list') {
                if (this.changes()) {
                    if(confirm('編集中ですが一覧に戻りますか？')) {
                        location.href = this.listUrl;
                        return false;
                    }
                } else {
                    location.href = this.listUrl;
                    return false;
                }
            }
            return false;
        },
        changes() {
            let isCustomerChange = this.customer !== this.customerSelected;
            if(this.customer === undefined) {
                isCustomerChange = this.customerSelected !== '';
            }
            let isPotentialUserChange = this.potentialUser !== this.potentialUserSelected;
            if(this.potentialUser === undefined) {
                isPotentialUserChange = this.potentialUserSelected !== '';
            }
            let isProductChange = this.product !== this.productSelected;
            if(this.product === undefined) {
                isProductChange = this.productSelected !== '';
            }
            let isPriceChange = this.price !== this.priceInput;
            if(this.price === undefined) {
                isPriceChange = this.priceInput !== "";
            }
            let isQuantityChange = this.quantity !== this.quantityInput;
            if(this.quantity === undefined) {
                isQuantityChange = this.quantityInput !== 1;
            }
            let isUnitChange = this.unit !== this.unitInput;
            if(this.unit === undefined) {
                isUnitChange = this.unitInput !== '';
            }
            let isAccuracyChange = this.accuracy !== this.accuracySelected;
            if(this.accuracy === undefined) {
                isAccuracyChange = this.accuracySelected !== '';
            }
            let isScheduledChange = this.scheduled !== this.datePickerInput;
            if(this.scheduled === undefined) {
                isScheduledChange = this.datePickerInput !== '';
            }
            let isNoteChange = this.note !== this.noteInput;
            if(this.scheduled === undefined) {
                isNoteChange = this.noteInput !== '';
            }

            this.isChanges = {
                'isCustomerChange': isCustomerChange,
                'isPotentialUserChange': isPotentialUserChange,
                'isProductChange': isProductChange,
                'isPriceChange': isPriceChange,
                'isQuantityChange': isQuantityChange,
                'isUnitChange': isUnitChange,
                'isAccuracyChange': isAccuracyChange,
                'isScheduledChange': isScheduledChange,
                'isNoteChange': isNoteChange,
            };

            return isCustomerChange
                || isPotentialUserChange
                || isProductChange
                || isPriceChange
                || isQuantityChange
                || isUnitChange
                || isAccuracyChange
                || isScheduledChange
                || isNoteChange;
        },
        textarea(e) {
            let vc = document.querySelector('.vc-container');
            let target = document.getElementById('floatingTextarea');
            if (target != null && vc.clientHeight > target.clientHeight) {
                target.style.height = this.noteHeight + 'px';
                let scrollHeight = target.scrollHeight;
                target.style.height = scrollHeight + 'px';
            }
        },
        async onSubmit(e) {
            let res = null;
            if (this.faqId > 0) {
                res = await this.api('/api/faq/update', {
                    'faq_id': this.faqId,
                    'user_type': this.userTypeSelected,
                    'customer_code': this.customerSelected,
                    'potential_user_id': this.potentialUserSelected,
                    'product_id': this.productSelected,
                    'product_price': this.priceInput,
                    'product_quantity': this.quantityInput,
                    'product_unit': this.unitInput,
                    'accuracy_id': this.accuracySelected,
                    'scheduled_date': this.datePickerInput,
                    'note': this.noteInput
                });
            } else {
                res = await this.api('/api/faq/store', {
                    'user_type': this.userTypeSelected,
                    'customer_code': this.customerSelected,
                    'potential_user_id': this.potentialUserSelected,
                    'product_id': this.productSelected,
                    'product_price': this.priceInput,
                    'product_quantity': this.quantityInput,
                    'product_unit': this.unitInput,
                    'accuracy_id': this.accuracySelected,
                    'scheduled_date': this.datePickerInput,
                    'note': this.noteInput
                });
            }

            if ('errors' in res) {
                this.$root.errors = res.errors;
                window.scrollTo(0, 0);
                return false;

            } else if (res == null) {
                alert('保存に失敗しました。');
                return false;

            } else {
                console.log(res);
                const url = new URL(this.listUrl);
                if (url.search.includes('success')) {
                    location.href = this.listUrl
                } else if (url.search) {
                    location.href = this.listUrl + '&success';
                } else {
                    location.href = this.listUrl + '?success';
                }
            }
        },
        customFilerBy (option, label, search) {
            return moji((label || ''))
                .convert('ZE', 'HE')
                .toString()
                .toLocaleLowerCase()
                .indexOf(
                    search.toLocaleLowerCase()
                ) > -1
        },
        getDate(value) {
            if (value == null) {
                return null;
            }
            if (/\d{4}\/\d{1,2}\/\d{1,2}/.test(value)) {
                return new Date(Date.parse(value));
            }
            return value;
        },
        getCompanyLabel(option){
            if(typeof option === 'object'){
                return option.company;
            }
            const optionObj = this.potentialUsers.find(item => item.id.toString() === option.toString());
            if(optionObj){
                return optionObj.company;
            }
            return option;
        }
    }
}
</script>

<style scoped>

</style>
